export const localStorageKeys = {
  auth: "@codilo/token",
  loginIds: "@codilo/login_ids",
};
